import {SUB_TYPES} from '@/features/measures/services/types.ts'
import {Chip} from '@components/ui/chip/Chip.tsx'
import {useTheme} from 'styled-components'
import {useTranslation} from 'react-i18next'

export const MeasureType = ({type}: {type: SUB_TYPES}) => {
    const theme = useTheme()
    const {t} = useTranslation()
    switch (type) {
        case SUB_TYPES.enum.judgment:
        case SUB_TYPES.enum.short_judgment:
        case SUB_TYPES.enum.judgment_device:
        case SUB_TYPES.enum.opinion:
        case SUB_TYPES.enum.interlocutory_opinion:
        case SUB_TYPES.enum.final_opinion:
        case SUB_TYPES.enum.suspensive_opinion:
        case SUB_TYPES.enum.precautionary_decree:
        case SUB_TYPES.enum.collegiate_decree:
        case SUB_TYPES.enum.dispositive_decree:
        case SUB_TYPES.enum.injunction_decree:
        case SUB_TYPES.enum.presidential_decree:
        case SUB_TYPES.enum.legal_aid:
        case SUB_TYPES.enum.precautionary_order:
        case SUB_TYPES.enum.collegial_order:
        case SUB_TYPES.enum.injunction_order:
        case SUB_TYPES.enum.presidential_order:
            return (
                <Chip
                    text={t(`measures:type:${type}`)}
                    bgColor={theme.palette.primary['100']}
                    textColor={theme.palette.primary['700']}
                />
            )
        default:
            return <Chip text={t('measures:type:other')} />
    }
}
